import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { trainingService } from '../services/trainingService'

export const useTrainingQueries = (
  skip: number,
  limit: number,
  search: string,
) => {
  return useQuery({
    queryKey: ['trainings', skip, limit, search],
    queryFn: async () => trainingService.getTrainings(skip, limit, search),
    placeholderData: keepPreviousData,
  })
}
